import TrendsAside from './TrendsAside';

import './assets/trends-aside.scss'

export default TrendsAside;